//import {detect} from 'detect-browser';
import Component from '../abstracts/Component';

export default class NavHeaderComponent extends Component {
    
    get SELECTORS() {
        return {
            main: 'js-navBtn',
            mobileNav: 'nav-mobile',
            mobileNavActions:'[data-nav="actions"]',
            mobileActions:'.actions-container',
            closeBtns:'.jsCloseBtn',
            header: '[data-componentpb*="NavHeaderComponent"]'
        };
    }

    get CSS_CUSTOMVARS() {
        return {
            jsHeightHeader: '--js-header-height'
        };
    }

    constructor() {
        super();
        this.idNavActionTop= 'actions-desktop';
        this.openNavClass  = 'open-nav';
        this.hideActionsBarClass = 'hide';
        this.activeClassMenuBtn = 'active-menu';
        this.header = document.querySelector(this.SELECTORS.header);
        this.headerHeight = this.header ? this.header.offsetHeight : 0;
    }

    initTrigger(){
        let menuType = document.getElementById('main-nav');
        let mqMobile = window.matchMedia('(max-width: 767px)');
        let btnEl = document.getElementById(this.SELECTORS.main);
        //When mobile:changes the trigger for mobile nav
        if(mqMobile.matches){
            console.log('Mobile Device');
            btnEl.dataset.navToggle = this.SELECTORS.mobileNav;
            menuType.dataset.menu = this.SELECTORS.mobileNav;
            this.triggerOpen(btnEl);
        }else{
            this.triggerOpen(btnEl);
        }
    }
    
    triggerOpen(btnTrigger) {
        
        let btnEl = btnTrigger;
        let layersContainer = document.getElementById('menu-layers-container');
        
        btnEl.addEventListener('click', () => {
            let selector = btnEl.dataset.navToggle;
            let isLayersActive = layersContainer.classList.contains('show-container');
            let navEls = document.querySelectorAll(`[data-menu=${selector}]`);
            
            if (selector == 'nav-mobile') {
                let actionBarTop = document.getElementById(this.idNavActionTop);
                actionBarTop.classList.toggle(this.hideActionsBarClass);
            }
            
            btnEl.classList.toggle(this.activeClassMenuBtn);
            for (let navEl of navEls) {
                if(typeof navEl !== 'undefined'){
                    navEl.classList.toggle(this.openNavClass);
                }
            }
            
            //If Layers active
            if (isLayersActive){
                layersContainer.classList.remove('show-container');
            }
        });
        
    }

    setCustomVar() {
        const root = document.documentElement;
        root.style.setProperty(this.CSS_CUSTOMVARS.jsHeightHeader, `${this.headerHeight}px`);
    }

    listenResize() {
        window.addEventListener('resize', () => {
        	this.headerHeight = this.header ? this.header.offsetHeight : 0;
            this.setCustomVar();
        });
    }

  render() {
    this.log('Rendering...');
    this.setCustomVar();
    this.listenResize();
    if (document.querySelectorAll(`#${this.SELECTORS.main}`).length) {
      this.initTrigger();
    }
  }
}
